import request from '@/utils/request';

// 今日/昨日充电量
export function getYesterdayOrTodayCharging (params) {
  return request({
    url: '/webapi/saasIgnore/screen/todatData',
    method: 'get',
    params,
  });
}

// 总累计充电量 数据统计
export function getDataStatistics (params) {
  return request({
    url: '/webapi/sheyang/saasIgnore/screen/dataStatistics',
    method: 'get',
    params,
  });
}
// 当前充电状况 数据统计
export function getChargeStatus (params) {
  return request({
    url: '/webapi/saasIgnore/screen/chargeStatus',
    method: 'get',
    params,
  });
}

// 电站总数
export function getStubGroupNumber (params) {
  return request({
    url: '/webapi/saasIgnore/screen/monitor/stubGroup/map/qry',
    method: 'get',
    params,
  });
}

// 近一个月充电电量与充电次数趋势
export function getMonthAnalyseData (params) {
  return request({
    url: '/webapi/saasIgnore/screen/monthAnalyseData',
    method: 'get',
    params,
  });
}

// 用户充电行为分析
export function getDayAnalyseData (params) {
  return request({
    url: '/webapi/saasIgnore/screen/dayAnalyseData',
    method: 'get',
    params,
  });
}

// 充电时段占比
export function getChargingFrame (params) {
  return request({
    url: '/webapi/saasIgnore/screen/chargingFrame',
    method: 'get',
    params,
  });
}

// 充电过程数据 列表
export function getChargingProcess (params) {
  return request({
    url: '/webapi/saasIgnore/screen/station/order/list',
    method: 'get',
    params,
  });
}

// 充电过程数据详情
export function getChargingProcessDetail (params) {
  return request({
    url: '/webapi/saasIgnore/screen/station/order/detail',
    method: 'get',
    params,
  });
}
